<template>
    <div>
        <button
            class="btn btn-outline-dark"
            @click="getClasses();classIn = !classIn"
        >Make Class Inactive</button>
        <br />
        <div v-if="classIn">
            <br />
            <b-form-select v-model="selectedClass3">
                <b-form-select-option :value="null">Please select an option</b-form-select-option>
                <b-form-select-option
                    v-for="selClass in classes"
                    :key="selClass"
                    :value="selClass"
                >{{selClass}}</b-form-select-option>
            </b-form-select>
            <br />
            <br />
            <button
                class="btn btn-sm btn-outline-warning"
                @click="classIn=false;classInactive()"
            >Submit</button>
        </div>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig");
const makeClassInactive = fb.functions.httpsCallable("makeClassInactive");
export default {
    data() {
        return {
            classIn: false,
            selectedClass3: null,
            classes: []
        };
    },
    methods: {
        getClasses() {
            if (this.classes.length) {
                return;
            }
            const queryClass = fb.db
                .collection("classes")
                .where("active", "==", true);
            queryClass.get().then(querySnapshot => {
                querySnapshot.forEach(doc => {
                    this.classes.push(doc.data().name);
                });
            });
        },
        classInactive() {
            makeClassInactive({
                class: this.selectedClass3
            }).then(res => {
                console.log(res.data);
                this.$emit(
                    'toast',
                    "war",
                    "Process complete. Check logs in developer console."
                );
            });
            this.selectedClass3 = "";
        }
    }
};
</script>